import { render, staticRenderFns } from "./AcceptTermsModal.vue?vue&type=template&id=7224cf60&"
import script from "./AcceptTermsModal.vue?vue&type=script&lang=ts&"
export * from "./AcceptTermsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports